module.exports = __webpack_public_path__ + "static/img/65065H_1_R_20200826_LC.e9a0386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/65065H_1_R_20200826_LC.png
// module id = BI+g
// module chunks = 0